import { z } from "zod";

const genericUtmSchema = z.object({
  utm_source: z.string(),
  utm_medium: z.string(),
  utm_campaign: z.string(),
  utm_term: z.string(),
  utm_content: z.string(),
});

export const marketingDataSchema = z
  .object({
    Meta: z
      .object({
        utm_source: z.string(),
        utm_medium: z.string(),
        utm_campaign: z.string(),
        utm_content: z.string(),
      })
      .optional(),
    Google: z
      .object({
        gclid: z.string(),
        utm_source: z.string(),
        utm_medium: z.string(),
        utm_campaign: z.string(),
        utm_term: z.string(),
        utm_content: z.string(),
      })
      .optional(),
    Bing: z
      .object({
        msclkid: z.string(),
        utm_source: z.string(),
        utm_medium: z.string(),
        utm_campaign: z.string(),
        utm_term: z.string(),
        utm_content: z.string(),
      })
      .optional(),
    Brevo: z
      .object({
        utm_source: z.string(),
        utm_campaign: z.string(),
        utm_medium: z.string(),
        utm_id: z.string(),
        utm_content: z.string(),
      })
      .optional(),
    X: z
      .object({
        utm_source: z.string(),
        utm_medium: z.string().optional(),
        utm_campaign: z.string().optional(),
        utm_content: z.string().optional(),
      })
      .optional(),
    Broadcast: genericUtmSchema.optional(),
    OpenAI: genericUtmSchema.optional(),
    Other: genericUtmSchema.optional(),
  })
  .optional();